// extracted by mini-css-extract-plugin
export var alternate = "_18-j";
export var black = "_18-6";
export var blue = "_18-f";
export var blueLight = "_18-e";
export var brand = "_18-8";
export var darkMode = "_18-b";
export var error = "_18-a";
export var gray = "_18-5";
export var grayBlue = "_18-d";
export var iconWrapper = "_18-3";
export var inactive = "_18-7";
export var indigo = "_18-g";
export var orange = "_18-i";
export var pink = "_18-h";
export var primary = "_18-0";
export var purple = "_18-9";
export var success = "_18-4";
export var warning = "_18-c";
export var white = "_18-1";
export var whiteSuccess = "_18-2";